import React, { Component } from "react";
import {Row, Col, Label, FormText, Button} from 'reactstrap';
import {mapType} from '../../../../../utils/constants';
import warningIcon from '../../../../../assets/warning.svg';
import './ReviewAlert.css';

const reviewAlert = (props) => {
  let alertSubHeading = null;
  // console.log(props);
  switch(props.type) {
    case mapType.orgChart: alertSubHeading = <span>
      You will always be able to add or remove admins, but to change the office hierachy you will have to contact 
      <a href="mailto:team@ouroffice.io" className="review-support-link"> team@ouroffice.io</a>, to protect for loss of tools, KPIs and other data associated with your current organizational hierarchy.
    </span>;
    break;
    case mapType.gender: alertSubHeading = <span>Please remember that changes to mappings are reflected for all future uploads 
      in all offices within your enterprise. You will always be able to change the mappings later but they will not influence historic uploads.</span>;
    break;
    case mapType.positions: alertSubHeading = <span>Please remember that changes to mappings are reflected for all future uploads 
      in all offices within your enterprise. You will always be able to change the mappings later but they will not influence historic uploads.</span>;
    break;
    case mapType.performance: alertSubHeading = <span>Please remember that changes to mappings are reflected for all future uploads 
      in all offices within your enterprise. You will always be able to change the mappings later but they will not influence historic uploads.</span>;
    break;
    case mapType.separation: alertSubHeading = <span>Please remember that changes to mappings are reflected for all future uploads 
      in all offices within your enterprise. You will always be able to change the mappings later but they will not influence historic uploads.</span>;
    break;
    case mapType.uploadEmployeeDataCsv : alertSubHeading = <span>{props.message}</span>;
    break;
    default: alertSubHeading = props.alertSubHeading
  }

    return (
      <Row className="review-alert-msg-bg mt40" style={{ marginLeft: '0px', marginRight: '0px' }}>
        <Col sm={1} md={1} style={{ paddingRight: '0px' }}>
          <span><img src={warningIcon} className="alert-i"/></span>
        </Col>
        <Col sm={11} md={11} className="alert-msg-ml-5">
          <Row><span className="review-alert-msg-text">{props.reviewHeading}</span></Row>
          <Row><span className="review-alert-msg-sub-text">{alertSubHeading}</span></Row>
        </Col>
      </Row>)
}

export default reviewAlert;